import {HttpClient} from "@angular/common/http";
import {inject, Service} from "@angular/core";
import type {IJsonObject} from "dcerialize";
import {Deserialize} from "dcerialize";
import type {Observable} from "rxjs";
import {map} from "rxjs";
import type {IPaginated, IPaginationQuery} from "../../models/IPaginated";
import {Timeline} from "../../models/Timeline/Timeline";
import type {TimelineEvent} from "../../models/Timeline/TimelineEvent";
import {BaseApiService} from "./base-api.service";

@Service()
export class TimelineService extends BaseApiService {
  private readonly http = inject(HttpClient);

  public constructor() {
    super("timeline");
  }

  public getTimeline(paginationQuery?: IPaginationQuery): Observable<IPaginated<TimelineEvent>> {
    const params = this.httpParamsFromPaginationQuery({
      sortBy: {
        field: "point-in-time",
        direction: "ascending",
      },
      ...(paginationQuery ?? {}),
    });
    return this.http.get<IJsonObject>(this.getEndpointUrl(), {params})
      .pipe(map(m => Deserialize(m, () => Timeline)));
  }
}
